import React from 'react'
import { Input } from 'semantic-ui-react'
import { Field } from 'redux-form'
import { LKDate } from 'loankeeper-common/helpers/Date'

import { ComponentContainer } from 'shared/StyledComponents'

import { datepickerNormalizer, handleKeyDown } from './helpers'

class InputField extends React.Component {
  handleInputBlur = (e) => {
    const { input, onBlur } = this.props

    input.onBlur(e)

    if (LKDate.isValid(e.target.value)) {
      input.onChange(LKDate.from(e.target.value).toString())
    }

    if (onBlur) onBlur(e.target.value)
  }

  render() {
    const {
      input,
      style,
      action,
      meta: { dirty, error },
      disabled,
    } = this.props

    return (
      <ComponentContainer input>
        <Input
          {...input}
          className={dirty && error ? 'failed-field' : undefined}
          style={style}
          fluid
          action={action}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          onBlur={this.handleInputBlur}
        />
      </ComponentContainer>
    )
  }
}

export const DecoratedRangePickerFirstField = (props) => (
  <Field {...props} component={InputField} normalize={datepickerNormalizer} />
)

export default InputField
